import React, {useState, useEffect, useContext} from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProgressSpinner } from "primereact/progressspinner";
import { useQueryGtfsResource } from "../../Queries";
import { ToolsContext, ToolsDispatchContext } from "../../ToolsContext";
import { formatGtfsTimeString } from "../../helpers/gtfsDateUtils";


export function TripsPicker() {
    const tool = useContext(ToolsContext);
    const toolDispatch = useContext(ToolsDispatchContext);
    const { isPending, error, data } = useQueryGtfsResource('trips');

    if (isPending || !data) {
        return <ProgressSpinner />;
    }

    if (error) {
        return (
            <>
                <i className="fa-solid fa-face-frown fa-5x"></i><br />
                Wystąpił błąd ładowania kursów: {error.message}
            </>
        )
    }

    const headerCalIco = <i className="fa-solid fa-calendar-days"></i>;


    return (
        <DataTable 
            paginator rows={18} rowsPerPageOptions={[18, 36, 50, 100, 200]} 
            style={{minWidth: '48vw'}} 
            scrollHeight="81.5vh" 
            removableSort 
            scrollable 
            dataKey="trip_id"
            value={data}
            size="small" 
            stripedRows 
            selectionMode="single"
            selection={(tool.selection) ? tool.selection : []}
            onRowDoubleClick={(e) => {
                toolDispatch({
                type: 'changed',
                newTool: {
                    ...tool,
                    selection: e.data, // zaznacz trasę
                    propertyEditor: {
                        edit: e.data
                    }
                }
                })}
            }
            onSelectionChange={(e) => {
                console.log('onSelChg',e);
                toolDispatch({
                type: 'changed',
                newTool: {
                    ...tool,
                    selection: e.value, // zaznacz trasę (wyjątkowo przepisujemy cały obiekt, z uwagi na charakterystykę komponentu DataTable używanego jako trip picker)
                    propertyEditor: null
                }
            })} 
            }
            tableStyle={{ minWidth: '50rem' }}
        >
            <Column field="trip_id" 
                sortable 
                headerTooltipOptions={{position: "bottom"}} 
                headerTooltip="Nr kursu" 
                header="Nr"
            />
            <Column field="route_id" 
                filter 
                headerTooltipOptions={{position: "bottom"}} 
                headerTooltip="ID linii" 
                sortable
                header="L." 
            />
            <Column field="service_id" 
                filter 
                sortable 
                headerTooltipOptions={{position: "bottom"}} 
                headerTooltip="Kalendarz" 
                header={headerCalIco}
            />
            <Column field="first_departure_time" 
                sortable 
                headerTooltipOptions={{position: "bottom"}} 
                headerTooltip="Godzina odjazdu z przystanku początkowego" 
                header="O." 
                body={(trip) => formatGtfsTimeString(trip.first_departure_time)}
            />
            <Column field="first_stop_name" 
                filter 
                sortable 
                headerTooltipOptions={{position: "bottom"}} 
                headerTooltip="Nazwa przystanku początkowego" 
                header="🚏 Początek"
            />
            <Column field="last_stop_name" 
                filter 
                sortable 
                headerTooltipOptions={{position: "bottom"}} 
                headerTooltip="Nazwa przystanku końcowego" 
                header="🚏 Koniec"
            />
            <Column field="last_arrival_time" 
                headerTooltipOptions={{position: "bottom"}} 
                headerTooltip="Godzina przyjazdu na przystanek końcowy" 
                sortable 
                header="P." 
                body={(trip) => formatGtfsTimeString(trip.last_arrival_time)}
            />
        </DataTable>            

    )
}